import axios from "axios";
import { axiosTransformJSON5 } from "@/common/helper";
import { IZuoraFormConfig, ICaptchaConfig, IPendoConfig, IFooterLinksConfig } from "./api/interfaces";

export interface IConfig {
  zuoraForm: IZuoraFormConfig;
  captcha: ICaptchaConfig;
  pendo: IPendoConfig;
  footerLinks: IFooterLinksConfig;
}

export default function (): Promise<IConfig> {
  return axios({
    method: "get",
    url: `config/config.json`,
    transformResponse: axiosTransformJSON5,
  }).then(res => {
    return res.data;
  });
}
